import {ModalComponents} from 'constants/Modals';

import React, {ReactNode} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import {templates} from 'features/beersManager/typescript';
import {PostTypes} from 'features/postGenerator/constants';
import Standard2 from 'features/postGenerator/templates/Standard2/Standard2';
import {postGeneratorSteps} from 'features/postGenerator/typescript';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';
import {PubBeer} from 'typescript/models/PubBeer';
import {getDefaultBackground} from 'utils/helpers/getBackground';

import Standard from '../../templates/Standard/Standard';
import './Post.scss';

interface IProps {
  imageUrl?: string;
  frontPage?: boolean;
  beers: PubBeer[];
  forwardRef?: (el: HTMLDivElement) => void;
  style?: React.CSSProperties;
}

export default function Post({imageUrl, frontPage = false, beers, forwardRef, style}: IProps) {
  const {postType, step, activeTemplate, postThumbnailFitType} = useGlobalState((state) => state.postGenerator);
  const dispatch = useSetGlobalState();

  const postStyles = {
    width: PostTypes[postType].width,
    height: PostTypes[postType].height,
    ...style,
  };

  const displayProperTemplate = (template: templates) => {
    const templatesComponents: {[key: string]: ReactNode} = {
      [templates.Standard]: <Standard beers={beers} frontPage={frontPage} />,
      [templates.Standard2]: <Standard2 beers={beers} frontPage={frontPage} />,
    };

    return templatesComponents[template];
  };

  return (
    <div className="generate-post" ref={forwardRef} style={postStyles}>
      {step === postGeneratorSteps.postTemplate && (
        <Button
          variant="default"
          className="generate-post__change-bg"
          onClick={() => {
            dispatch(setModalAC(ModalComponents.POST_CHANGE_BACKGROUND));
          }}
        >
          <Icon icon="pencil" />
        </Button>
      )}
      <div
        className="generate-post__content"
        style={{
          backgroundImage: `url(${imageUrl || getDefaultBackground(activeTemplate, step)})`,
          backgroundSize: postThumbnailFitType,
          backgroundRepeat: 'no-repeat',
          marginTop: step === 'SELECT_POST_TYPE' && postType === 'pubTV' ? '100px' : '0px',
        }}
      >
        {step === 'SELECT_POST_TEMPLATE' && displayProperTemplate(activeTemplate)}
      </div>
    </div>
  );
}
